const STORAGE_KEY = 'tournamentApp.favorites.v1';

/** Limpia favoritos guardados en el navegador (p. ej. al cerrar sesión). */
export function clearFavoriteTournamentsLocal() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** @returns {{ id: string, name: string }[]} */
export function getFavoriteTournaments() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((x) => x && x.id && x.name)
      .map((x) => ({ id: String(x.id), name: String(x.name) }));
  } catch {
    return [];
  }
}

function save(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

/** @param {{ id: string, name: string }} entry */
export function addFavoriteTournament(entry) {
  const id = String(entry.id);
  const name = String(entry.name || 'Torneo');
  const current = getFavoriteTournaments().filter((x) => x.id !== id);
  current.unshift({ id, name });
  save(current.slice(0, 50));
}

export function removeFavoriteTournament(id) {
  const sid = String(id);
  save(getFavoriteTournaments().filter((x) => x.id !== sid));
}

export function isFavoriteTournament(id) {
  return getFavoriteTournaments().some((x) => x.id === String(id));
}

/** @param {{ id: string, name: string }} entry */
export function toggleFavoriteTournament(entry) {
  if (isFavoriteTournament(entry.id)) {
    removeFavoriteTournament(entry.id);
    return false;
  }
  addFavoriteTournament(entry);
  return true;
}
